import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { RegisterDto } from "~/data/user/register.dto";

import { register } from "~/data/user/user.service";

import { Field } from "../shared/field";
import { Button } from "../shared/button";
import { Input, InputPassword } from "../shared/input";

export function Register() {
  const navigate = useNavigate();
  const form = useForm<RegisterDto>();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (dto: RegisterDto) => register(dto),
    onSuccess: (data) => queryClient.setQueryData(["user"], data),
  });
  const onSubmit = form.handleSubmit((data) =>
    mutation.mutate(data, { onSuccess: () => navigate("/") })
  );

  return (
    <form onSubmit={onSubmit} className="flex flex-col items-center w-full">
      <h2 className="text-primary-1 text-2xl lg:text-3xl font-semibold mb-5 lg:mb-10 text-center">
        Crie sua conta
      </h2>

      <div className="w-[460px] max-w-full">
        <Field label="Nome Completo" className="mb-2">
          <Input
            {...form.register("name", { required: "Campo obrigatório" })}
            placeholder="Informe seu nome completo"
            type="text"
          />
        </Field>

        <Field label="E-mail" className="mb-2">
          <Input
            {...form.register("email", { required: "Campo obrigatório" })}
            placeholder="Informe um e-mail válido"
            type="email"
          />
        </Field>

        <Field label="Senha" className="mb-2">
          <InputPassword
            {...form.register("password", {
              required: "Campo obrigatório",
            })}
            placeholder="Informe sua senha"
            id="password"
          />
        </Field>

        <Field label="Confirmar Senha" className="mb-5 lg:mb-10">
          <InputPassword
            {...form.register("password_confirmation", {
              required: "Campo obrigatório",
            })}
            placeholder="Deve ser a mesma senha informada acima"
          />
        </Field>
      </div>

      <Button
        className="h-10 w-60 max-w-full my-5"
        loading={mutation.isPending}
        type="submit"
        variant="primary-1"
      >
        Registrar conta
      </Button>
      <Button
        className="h-10 w-60 max-w-full mb-10"
        asChild
        variant="primary-1"
      >
        <Link to="/entrar">Voltar para tela de login</Link>
      </Button>
    </form>
  );
}
